import { create } from 'zustand';

export type ActivityPayload = {
    type: 'resource:view' | 'resource:edit' | 'idle';
    resourceType?: 'folder' | 'investment' | 'memo' | 'pipeline' | 'dashboard' | 'list';
    resourceId?: string;
    timestamp: number;
};

type ActivityState = {
    users: Record<string, ActivityPayload>;
    update: (id: string, payload: ActivityPayload) => void;
};

export const useActivityStore = create<ActivityState>((set) => ({
    users: {},
    update: (id, payload) =>
        set((s) => ({
            users: {
                ...s.users,
                [id]: payload,
            },
        })),
}));
